/**
 * THIS FILE SHOULD BE TEMPORARY.
 *
 * Some of these functions are required for backwards compatability.
 */
/**
 * Converts any instances of dev to mwtesting
 *
 * This function performs the following transformations:
 * - If the input string is exactly equal to "dev", it returns "mwtesting".
 * - If the input string contains the segment "/dev/", it replaces all occurrences of "dev" with "mwtesting".
 * - If none of the above conditions are met, it returns the input string unchanged.
 *
 * @param {string} str - The input string to be transformed.
 * @returns {string} - The transformed string with "dev" converted to "mwtesting", if applicable.
 */
export const convertDevToMWTesting = (str: string | undefined): string | undefined => {
  if (str === 'dev') {
    return 'mwtesting'
  }

  if (str?.includes('/dev/')) {
    return str.replace(/dev/g, 'mwtesting')
  }

  return str
}
